import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

const LineItemResidualWalletMaybe = props => {
  const { remainingWalletBalance, currency, intl } = props;

  // Only show if there's remaining wallet balance after discount
  if (!remainingWalletBalance || remainingWalletBalance <= 0) {
    return null;
  }

  const formattedBalance = formatMoney(intl, new Money(remainingWalletBalance, currency));

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="BookingTimeForm.walletCredit" />
      </span>
      <span className={css.itemValue}>{formattedBalance}</span>
    </div>
  );
};

export default LineItemResidualWalletMaybe;
